module.exports = __webpack_public_path__ + "img/CAnnectLogo.2bd963ee.svg";